import classNames from "classnames";
import PropTypes from "prop-types";
import React, { useContext, useEffect, useState } from "react";
import { LanguageContext } from "../../../contexts/Language";
import { Clickable } from "../../button/Clickable";
import { Icon } from "../../graphic/Icon";
import { fetchExternalStatus } from "./service";
import styles from "./SystemBanner.scss";
import { useLocation } from "react-router-dom";
import config from "../../../config";
import { parseSitePath } from "../../../utils/siteRoutes";

const excludedPaths = ["/pricing", "/contact", "/printable"];

export const SystemBanner = () => {
    const isEnabled = config.SYSTEM_STATUS_BANNER_ENABLE === "true";
    const { language } = useContext(LanguageContext);
    const location = useLocation();
    const [message, setMessage] = useState(null);
    const [closedKeys, setClosedKeys] = useState([]);

    useEffect(() => {
        if (!isEnabled) return;

        (async () => {
            const msgList = await fetchExternalStatus();
            setMessage(msgList.length > 0 ? msgList[0] : null);
        })();

        const id = setInterval(async () => {
            const msgList = await fetchExternalStatus();
            setMessage(msgList.length > 0 ? msgList[0] : null);
        }, 60000);

        return () => clearInterval(id);
    }, []);

    // Paths without the language prefix of the public pages (/no/pricing → /pricing)
    const { path } = parseSitePath(location.pathname);

    return message &&
        !excludedPaths.some((p) => path.startsWith(p)) &&
        path !== "/" &&
        !closedKeys.includes(message.key) ? (
        <div
            className={classNames(styles.banner, {
                [styles.info]: message.type === "info",
                [styles.warning]: message.type === "warning"
            })}
        >
            <div className={styles.inner}>
                <span className={styles.icon}>
                    <Icon name={message.type === "warning" ? "exclamation-circle" : "info"} />
                </span>
                <span className={styles.message}>{message[`message_${language.locale}`]}</span>
                <span className={styles.close}>
                    <Clickable onClick={() => setClosedKeys([...closedKeys, message.key])}>
                        <Icon name="close" />
                    </Clickable>
                </span>
                <div className={styles.background} />
            </div>
        </div>
    ) : null;
};

SystemBanner.propTypes = {
    message: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    color: PropTypes.oneOf(["info", "warning"]),
    className: PropTypes.string
};

SystemBanner.defaultProps = {
    color: "info",
    className: null
};
